module.exports = __webpack_public_path__ + "static/snowball-logo-blue-82510bec51017ce03b153abf5d56c66a.png";